import AuthLayout from "../../components/Auth/AuthLayout";
import AuthPageHelmet from "../../components/Auth/AuthPageHelmet";
import Chip from "@mui/material/Chip";
import {
  AUTH_LOGIN_OWNER_CHIP_LABEL,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER,
} from "../../i18n/keysTranslations";
import LoginFormOwner from "./components/LoginFormOwner";
import { useSelectorApp } from "../../lib/redux";
import { useTranslationApp } from "../../lib/i18next";
import {
  BORDER_GRAY_COLOR,
  GRAY_COLOR_TEXT_DISABLED,
  GRAY_100_SOLID,
} from "../../utils/colors";

const LoginOwner = () => {
  const { theme } = useSelectorApp((state) => state.ui);
  const { t } = useTranslationApp();

  const ownerChip = (
    <Chip
      label={t(AUTH_LOGIN_OWNER_CHIP_LABEL)}
      size="small"
      sx={{
        height: 25,
        fontWeight: 600,
        backgroundColor: GRAY_100_SOLID,
        color: GRAY_COLOR_TEXT_DISABLED,
        border: `1px solid ${BORDER_GRAY_COLOR}`,
        "& .MuiChip-label": { px: 1, fontSize: "11px" },
      }}
    />
  );

  return (
    <AuthLayout
      showFeatures={false}
      fitCardToContent={true}
      cardCornerContent={ownerChip}
    >
      <AuthPageHelmet
        documentTitleKey={AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER}
        nameBusiness={theme.nameBusiness}
      />
      <LoginFormOwner />
    </AuthLayout>
  );
};

export default LoginOwner;
